<div class="code-preview">
  <!-- <div class="line-numbers">
    <span *ngFor="let line of lines">{{line}}</span>
  </div> -->
  <pre><code [innerHTML]="content"></code></pre>
</div>
